module.exports = __webpack_public_path__ + "static/media/Amazonlogo.d5b8ec76.png";